import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import { LoadingScreen } from 'ComponentLibrary';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate, redirect, useLocation, useMatch, useNavigate } from 'react-router-dom';
import {
  useAwaitTokenHasBeenRefreshed,
  useIsAdmin,
  useCurrentPage,
} from 'utilities/HooksAndSelectors';
import { CSSTransition } from 'react-transition-group';
import { createSaveUsersDestinationForAfterLoginAction } from 'redux/actions/Login/LoginActions';

const WithRedirect = (props) => {
  const navigate = useNavigate();
  const { page, children, adminOnly, path } = props;

  const refreshed = useAwaitTokenHasBeenRefreshed();
  const user = useSelector((reduxState) => reduxState.userState);
  const currentPage = useCurrentPage();
  const userDetails = user ? user.userDetails : null;
  const afterSuccessfulLogin = userDetails
    ? userDetails.afterSuccessfulLogin
    : null;
  const location = useLocation();
  const dispatch = useDispatch();
  const isAdmin = useIsAdmin();
  const match = useMatch({
    path: path || "",
    exact: true,
  });

  if (!isAdmin && adminOnly) {

    navigate('/dashboard');
    return;//
  }
  if (!refreshed) {
    return null;
  }
  const { pathname } = location;
  const isExternalRedirect =
    pathname.indexOf('/financing/loanapplication') >= 0 ||
    pathname.indexOf('/envision') >= 0 ||
    pathname.indexOf('/designcenter/confirmedselections') >= 0 ||
    pathname.indexOf('/warranty/manual') >= 0 ||
    pathname.indexOf('/wellsfargo') >= 0;

  if (
    !isExternalRedirect &&
    currentPage !== page &&
    refreshed &&
    page !== 'admin'
  ) {
    switch (currentPage) {
      case 'dashboard':
        const whereIAmGoing =
          afterSuccessfulLogin !== null &&
            afterSuccessfulLogin !== undefined &&
            afterSuccessfulLogin !== '' &&
            afterSuccessfulLogin !== '/'
            ? afterSuccessfulLogin
            : `/dashboard${location.pathname.startsWith('/dashboard')
              ? location.pathname.substr(10)
              : ''
            }`;

        return <Navigate to={whereIAmGoing} />;//<Redirect to={whereIAmGoing} />;
        return null;
      case 'findLot':

        return <Navigate to='/find-lot' />;//<Redirect to='/find-lot' />;
      case 'lotAssociation':

        return <Navigate to='/lot-association' />;
      default:
        if (
          location.pathname + window.location.hash !== afterSuccessfulLogin &&
          location.pathname.indexOf('login') < 0
        ) {
          dispatch(
            createSaveUsersDestinationForAfterLoginAction(
              location.pathname + window.location.hash
            )
          );
        }
        return <Navigate to={`/login${location.search}`} />;
        return redirect(`/login${location.search}`);//<Redirect to={` / login${ location.search } `} />;
    }
  }

  const isAnimatable = true;
  return (
    <Suspense
      fallback={<LoadingScreen exit={false} variant={null} color={null} />}
    >
      <CSSTransition
        in={match != null}
        appear={match != null}
        timeout={400}
        classNames={isAnimatable ? 'slide' : ''}
        exit={match === null}
        unmountOnExit
      >
        {children}
      </CSSTransition>
    </Suspense>
  );

};

WithRedirect.propTypes = {
  adminOnly: PropTypes.bool,
};
WithRedirect.defaultProps = {
  adminOnly: false,
};
export default WithRedirect;
